import React, { useState } from "react";
import Input from "../../../../../components/Input";
import Button from "../../../../../components/Button";
import { useNavigate } from "react-router-dom";
import { USER_ROUTES } from "../../../../../constants/appRoutes";

const EmiCalculate = ({ baseAmount }: { baseAmount: number }) => {
  const navigate = useNavigate();
  const [year, setYear] = useState("2");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    if (!year) {
      setError("Tenure is required");
      return;
    }

    const tenure = parseInt(year, 10);

    if (isNaN(tenure) || tenure < 1) {
      setError("Tenure must be at least 1 year");
      return;
    }

    if (tenure > 30) {
      setError("Tenure cannot be more than 30 years");
      return;
    }

    setError("");

    navigate(USER_ROUTES.EMI_CALCULATOR, {
      state: {
        baseAmount: baseAmount,
        interest: 8.5,
        tenure: tenure,
      },
    });
  };

  return (
    <div className="shadow shadow-black/40 p-4 rounded">
      <div className="space-y-4">
        <h1 className="font-semibold text-2xl text-center">EMI Calculator</h1>
        <div>
          <Input
            label="Base Price"
            name="baseAmount"
            id="baseAmount"
            value={baseAmount}
            onChange={() => {}}
            disabled
            readOnly
            autoComplete="off"
          />
          <Input
            label="Tenure (Years between 2 to 30)"
            name="years"
            id="year"
            placeholder="enter tenure in Years between 2 to 30"
            value={year}
            min={2}
            max={30}
            required
            error={error}
            maxLength={2}
            autoComplete="off"
            onChange={(e) => {
              setYear(e.target.value);
            }}
          />
          <div className="mt-8">
            <Button className="rounded-lg w-full" onClick={handleCalculate}>
              Calculate
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmiCalculate;
